import React, { useContext, useEffect, useRef, useState } from 'react';
import { useLazyQuery } from '@apollo/client';
//import { parseRawData } from '../../parsers';
import _ from 'lodash';
import { getProfitPoolData, getSalesAttribute } from 'gqlQueries/growthAnalysisQueries';
import { salesAttributeDataParser } from 'parser/salesAttributionDataParser';

const errorMessage: string = 'Something went wrong!';

function useFetchProfitPool() {
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<null | string>(null);
    const [data, setData] = useState<any | null>(null);
    const [extraData, setExtraData] = useState<any | null>(null);

    const [fetchProfitPool, { data: attributeSalesData, loading: attributeSalesLoading, error: attributeSalesError }] =
        useLazyQuery(getProfitPoolData, {
            onCompleted: onFetchComplete,
            onError: onFetchError,
        });

    //called when fetching is complete
    function onFetchComplete(payload: any) {
        try {
            const { getSalesAttributionProfit: featureGroup } = payload;
            //const featureGroup = payload;
            //if data present parse it
            if (featureGroup && Array.isArray(featureGroup)) {
                const parsedData1 = salesAttributeDataParser(featureGroup[0], true, 'retailer');
                const parsedData2 = salesAttributeDataParser(featureGroup?.[1], true, 'own');
                const data1 = parsedData1.data;
                const data2 = parsedData2.data;
                const extraData1 = parsedData1.extra;
                const extraData2 = parsedData2.extra;
                setData({ data1, data2 });
                setExtraData({ extraData1, extraData2 });
                return;
            }
        } catch (error) {
            console.error(errorMessage, error);
        } finally {
            setLoading(false);
        }
    }

    //called when API throws an error
    function onFetchError(error: any = errorMessage) {
        //sending empty data to error to avoid null data being sent
        setData(null);
        setLoading(false);
        setError(error);
    }

    return {
        loading,
        error,
        data,
        extra: extraData,
        fetchProfitPool: (variables: any) => {
            setData(null);
            setExtraData(null);
            setLoading(true);
            fetchProfitPool(variables);
        },
    };
}

export { useFetchProfitPool };
